<template>
  <el-dialog title="添加商品" width="70%" v-model="visible">

    <el-input v-model="query" placeholder="请输入商品名称" style="width:300px" />
    <el-button type="primary" @click="fetch">查询</el-button>


    <el-table :data="list" @selection-change="sel = $event" border style="margin-top:10px">
      <el-table-column type="selection" width="50" />
      <el-table-column prop="spuCode" label="商品编码" />
      <el-table-column prop="spuName" label="商品名称" />
      <el-table-column prop="stockNum" label="库存" />
    </el-table>

    <el-pagination
      style="margin-top:10px"
      layout="prev, pager, next"
      :total="total"
      v-model:current-page="page"
      @current-change="fetch"
    />

    <template #footer>
      <el-button @click="visible=false">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import {  useCurrentAppInstance } from '@zto/zpage'
const app = useCurrentAppInstance()
const props = defineProps<{ visible:boolean }>()
const emit = defineEmits(['update:visible','confirm'])
const visible = ref(props.visible)
watch(() => props.visible, v => visible.value = v)
watch(visible, v => emit('update:visible', v))

const query = ref('')
const page = ref(1)
const total = ref(100)
const list = ref<any[]>([])
const sel = ref<any[]>([])

const fetch = async () => {
  list.value = await app.request({
    api: 'pc/goods/querySpuInfoList',
    params: {
      pageSize:10,
      pageIndex:1,
    }
  })
}

const confirm = () => {
  emit('confirm', sel.value)
  visible.value = false
}

fetch()
</script>
